import { useCallback, useEffect, useState } from "react";
import { api, unwrapArray } from "@/lib/api";

export interface SavedView {
  id: string;
  module: string;
  name: string;
  config: Record<string, any>;
  /** Shared with the creator's team or the company (null: private) */
  shared?: "team" | "company" | null;
  /** false: made by someone else and shared with this person */
  mine?: boolean;
  shared_by?: string;
}

/** The signed-in person's saved views (or pins) for one module, kept on the server */
export function useSavedViews(module: string) {
  const [views, setViews] = useState<SavedView[]>([]);

  const reload = useCallback(
    () =>
      api
        .get(`/api/SavedView/List?module=${module}`)
        .then((r) => setViews(unwrapArray<SavedView>(r)))
        .catch(() => undefined),
    [module],
  );

  useEffect(() => {
    reload();
  }, [reload]);

  const save = async (name: string, config: Record<string, any>, share?: "team" | "company" | null) => {
    await api.post("/api/SavedView/Save", { module, name, config, share: share || null });
    await reload();
  };
  const remove = async (id: string) => {
    await api.post("/api/SavedView/Delete", { id });
    setViews((cur) => cur.filter((v) => v.id !== id));
  };

  return { views, save, remove, reload };
}
